import { render } from "./EmissionFilterFleet.vue?vue&type=template&id=2720aff0&scoped=true"
import script from "./EmissionFilterFleet.vue?vue&type=script&lang=js"
export * from "./EmissionFilterFleet.vue?vue&type=script&lang=js"

import "./EmissionFilterFleet.vue?vue&type=style&index=0&id=2720aff0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2720aff0"]])

export default __exports__